import { Card, Flex, Grid, Label, NewCard, Span, styled } from '@fareye/ui'
import { formatMs, getColorAfterComparing, isEmpty } from '@fareye/utils'
import { downloadToCSV } from '@fareye/common'

import React from 'react'
// import '../../../style/style.css'
import {
  TripTabDetailsGrid,
  MapDescription,
  OverflowWrapper,
  SideBarListing,
  SidebarListingContainer,
  GenericDetailsContainer
} from '../../../style/styled'
import { labelColor } from '../../../utility/colors'
import { tripDetailConstant } from '../../../utility/constants'
import {
  ISlider,
  IStyleProps,
  ITripTabDetailsProps,
  ITab
} from '../../../utility/types'
import { ExceptionsListing } from '../components/ExceptionsListing'
import { HistoryListing } from '../components/HistoryListing'
import { LoadsensorListing } from '../components/LoadsensorListing'
import { DocumentsListing } from '../components/DocumentsListing'
import { OverspeedListing } from '../components/OverspeedListing'
import { StoppageListing } from '../components/StoppageListing'
import TripDetails from '../components/TripDetails'
import TripMap from '../components/TripMap'
import Epod from '../components/Epod'
import Issues from '../components/Issues'
import { statusColorOption, tripColors } from '@fareye/configs'

const statusColor: any = {
  ...statusColorOption
}

const style: IStyleProps = {
  mapListGrid: {
    background: tripColors.mapListGrid,
    position: 'relative',
    height: 'inherit'
  },
  exceptionWrapper: {
    background: tripColors.exceptionWrapper,
    padding: '1em 1em',
    overflowY: 'auto'
  },
  tripStatus: {
    marginLeft: 4,
    backgroundColor: tripColors.tripStatus,
    borderRadius: '4px',
    border: '1px solid ',
    padding: '2px 5px 2px',
    fontWeight: 700,
    height: 'fit-content'
  },
  tripMaterial: {
    marginTop: 5,
    backgroundColor: tripColors.tripMaterial,
    borderRadius: '4px',
    padding: '4px 10px 2px',
    fontWeight: 700,
    width: 'auto'
  },
  tripTabs: {
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
    backgroundColor: tripColors.tripTabs,
    height: '50px'
  }
}

const TripTabDetails = ({
  data,
  plant,
  match,
  mapKey,
  history,
  location,
  onSelect,
  defaultTab,
  selectedIds,
  mapInfoToggle,
  defaultBaseLayer,
  isShare,
  moveMarker,
  listItems,
  config,
  apiBasedDailyDistanceGraph,
  aerisLayer,
  onTrackingProviderChange,
  trackingProvider
}: ITripTabDetailsProps) => {
  const tripTabItems = config
    ? config[0]?.tripTabItems
      ? config[0]?.tripTabItems
      : []
    : []
  const historyConfig =
    config && config.find((item: any) => item.label === 'History')
  const [mapData, setMapData] = React.useState(data)
  const [showTripPois, setShowTripPois] = React.useState(true)
  const [sideBarTab, setSideBarTab] = React.useState<ITab>(defaultTab)
  const [exceptionSlider, setExceptionSlider] = React.useState<ISlider>(
    !isEmpty(data.exceptions)
      ? {
          min: Math.min(
            ...data.exceptions.map((h: any) => new Date(h.createdAt).getTime())
          ),
          max: Math.max(
            ...data.exceptions.map((h: any) => new Date(h.createdAt).getTime())
          )
        }
      : {}
  )

  const [currExceptionSlider, setCurrExceptionSlider] = React.useState<ISlider>(
    !isEmpty(data.exceptions)
      ? {
          min: Math.min(
            ...data.exceptions.map((h: any) => new Date(h.createdAt).getTime())
          ),
          max: Math.max(
            ...data.exceptions.map((h: any) => new Date(h.createdAt).getTime())
          )
        }
      : {}
  )
  const [historySlider, setHistorySlider] = React.useState(
    data.histories
      ? {
          min: Math.min(
            ...data.histories.map((h: any) =>
              new Date(h.istTimestamp).getTime()
            )
          ),
          max: Math.max(
            ...data.histories.map((h: any) =>
              new Date(h.istTimestamp).getTime()
            )
          )
        }
      : {}
  )
  const [currHistorySlider, setCurrHistorySlider] = React.useState(
    data.histories
      ? {
          min: Math.min(
            ...data.histories.map((h: any) =>
              new Date(h.istTimestamp).getTime()
            )
          ),
          max: Math.max(
            ...data.histories.map((h: any) =>
              new Date(h.istTimestamp).getTime()
            )
          )
        }
      : {}
  )
  const [stoppageSlider, setStoppageSlider] = React.useState(
    !isEmpty(data.stoppages)
      ? {
          min: Math.min(...data.stoppages.map((h: any) => h.duration * 1000)),
          max: Math.max(...data.stoppages.map((h: any) => h.duration * 1000))
        }
      : {}
  )
  const [currStoppageSlider, setCurrStoppageSlider] = React.useState(
    !isEmpty(data.stoppages)
      ? (Math.max(...data.stoppages.map((h: any) => h.duration * 1000)) +
          Math.min(...data.stoppages.map((h: any) => h.duration * 1000))) /
          2
      : null
  )
  const [overspeedSlider, setOverspeedSlider] = React.useState(
    data.overspeedInstances
      ? {
          min: Math.min(...data.overspeedInstances.map((h: any) => h.speed)),
          max: Math.max(...data.overspeedInstances.map((h: any) => h.speed))
        }
      : { min: 0, max: 0 }
  )

  const [currOverspeedSlider, setCurrOverspeedSlider] = React.useState(
    data.overspeedInstances
      ? Math.max(...data.overspeedInstances.map((h: any) => h.speed))
      : 0
  )
  React.useEffect(() => {
    setStoppageSlider(
      !isEmpty(data.stoppages)
        ? {
            min: Math.min(...data.stoppages.map((h: any) => h.duration * 1000)),
            max: Math.max(...data.stoppages.map((h: any) => h.duration * 1000))
          }
        : {}
    )
    setCurrStoppageSlider(
      !isEmpty(data.stoppages)
        ? (Math.max(...data.stoppages.map((h: any) => h.duration * 1000)) +
            Math.min(...data.stoppages.map((h: any) => h.duration * 1000))) /
            2
        : null
    )
  }, [data.stoppages])

  React.useEffect(() => {
    setExceptionSlider(
      !isEmpty(data.exceptions)
        ? {
            min: Math.min(
              ...data.exceptions.map((h: any) =>
                new Date(h.createdAt).getTime()
              )
            ),
            max: Math.max(
              ...data.exceptions.map((h: any) =>
                new Date(h.createdAt).getTime()
              )
            )
          }
        : {}
    )
    setCurrExceptionSlider(
      !isEmpty(data.exceptions)
        ? {
            min: Math.min(
              ...data.exceptions.map((h: any) =>
                new Date(h.createdAt).getTime()
              )
            ),
            max: Math.max(
              ...data.exceptions.map((h: any) =>
                new Date(h.createdAt).getTime()
              )
            )
          }
        : {}
    )
  }, [data.exceptions])

  React.useEffect(() => {
    setMapData({
      ...mapData,
      exceptions: data.exceptions.filter((item: any) => {
        return currExceptionSlider &&
          currExceptionSlider.min &&
          currExceptionSlider.max
          ? new Date(item.createdAt).getTime() >= currExceptionSlider.min &&
              new Date(item.createdAt).getTime() <= currExceptionSlider.max
          : true
      }),
      stoppages: data.stoppages.filter((item: any) => {
        return currStoppageSlider
          ? item.duration * 1000 >= currStoppageSlider
          : true
      }),
      histories: data.histories.filter((item: any) => {
        return currHistorySlider &&
          currHistorySlider.min &&
          currHistorySlider.max
          ? new Date(item.istTimestamp).getTime() >= currHistorySlider.min &&
              new Date(item.istTimestamp).getTime() <= currHistorySlider.max
          : true
      }),
      overspeedInstances: data.overspeedInstances
        ? data.overspeedInstances.filter((item: any) => {
            return currOverspeedSlider
              ? item.speed <= currOverspeedSlider
              : true
          })
        : []
    })
  }, [
    currOverspeedSlider,
    currExceptionSlider,
    currStoppageSlider,
    currHistorySlider
  ])

  React.useEffect(() => {
    if (!isEmpty(data.histories)) {
      const min = Math.min(...data.histories.map((h: any) => new Date(h.istTimestamp).getTime()))
      const max = Math.max(...data.histories.map((h: any) => new Date(h.istTimestamp).getTime()))
      setHistorySlider({ min, max })
      setCurrHistorySlider({ min, max })
    }
    setMapData((prev: any) => ({ ...prev, histories: data.histories }))
  }, [data.histories])

  React.useEffect(() => {
    if (!showTripPois) {
      let tripMapData = { ...data }
      tripMapData.tripPois = []
      setMapData(tripMapData)
    } else {
      setMapData(data)
    }
  }, [showTripPois])

  function downloadCsv(downloadData: any, fields: string[]) {
    try {
      downloadToCSV({
        data: downloadData,
        options: { fields },
        fileName: downloadData[0].vehicleNo
      })
    } catch (err:any) {
      console.error(err)
    }
  }
  React.useEffect(() => {
    onSelect({
      stoppageId: 0,
      overspeedInstanceId: 0,
      locationId: 0,
      exceptionId: 0
    })
  }, [sideBarTab])

  const showReference = !!data.trip.referenceNo
  const is_weight = 'weight' in (data.histories?.[0]?.extraData ?? {});
  const is_document = !!(mapData?.trip?.driverLicenceUrl || mapData?.trip?.vehicleRcUrl);

  return (
    <TripTabDetailsGrid>
      {mapData ? (
        <Grid
          gridTemplateRows="minmax(75px, max-content) auto"
          style={{ height: '100%' }}
        >
          <Card variant="xs">
            <GenericDetailsContainer showReference={showReference}>
              <Flex
                column
                alignItemsFlexStart
                style={{ gridArea: 'route', width: '100%' }}
              >
                <Flex>
                  <Span variant="h5" style={{ fontWeight: 800 }}>
                    {`${data.trip.origin} - ${data.trip.destination}`}
                  </Span>
                  {data.trip.status && (
                    <div>
                      <Span
                        style={style.tripStatus}
                        color={statusColor[data.trip.status.toLowerCase()]}
                      >
                        {data.trip.status}
                      </Span>
                    </div>
                  )}
                </Flex>
                {data.trip.material ? (
                  <Label variant="h6" style={style.tripMaterial}>
                    {data.trip.material}
                  </Label>
                ) : null}
              </Flex>
              <Grid
                style={{
                  gridTemplateAreas: `"invoiceNo, referenceNo" "invoiceQty, netWt"`,
                  gridTemplateColumns: '1fr 1fr',
                  width: '150%'
                }}
              >
                {listItems.map((item: any) => {
                  const { key, label } = item
                  return (
                    <Flex key={key} column>
                      <Label>{label}</Label>
                      <Span
                        variant="h5"
                        style={{ fontWeight: 800, marginBottom: '10px' }}
                      >
                        {data.trip[key] ? data.trip[key] : '-'}
                      </Span>
                    </Flex>
                  )
                })}
              </Grid>
              <Flex column style={{ gridArea: 'vehicle', width: '100%' }}>
                {data.trip.vehicleNo && (
                  <Span variant="h5" style={{ fontWeight: 800 }}>
                    {data.trip.vehicleNo}
                  </Span>
                )}
                {data.trip.transporter && (
                  <Label style={{ fontSize: 12 }}>
                    {data.trip.transporter}
                  </Label>
                )}
              </Flex>
            </GenericDetailsContainer>
          </Card>
          <Flex column style={style.mapListGrid}>
            {mapInfoToggle ? (
              <>
                <MapDescription column>
                  <Flex justifyContentSpaceBetween>
                    <Span
                      variant={'h5'}
                      style={{ marginBottom: '2px' }}
                      color={
                        getColorAfterComparing(
                          mapData.trip && mapData.trip.actualTransitTime,
                          mapData.trip && mapData.trip.targetTransitTime
                        ).block
                      }
                    >
                      {`${
                        mapData.trip.isActive
                          ? 'Enroute Since'
                          : 'In-Transit TAT'
                      }`}
                    </Span>
                    <Span
                      variant={'h5'}
                      style={{ marginBottom: '2px' }}
                      color={
                        getColorAfterComparing(
                          mapData.trip && mapData.trip.actualTransitTime,
                          mapData.trip && mapData.trip.targetTransitTime
                        ).block
                      }
                    >
                      {mapData.trip && formatMs(mapData.trip.actualTransitTime)}
                    </Span>
                  </Flex>
                  <Flex justifyContentSpaceBetween>
                    <Span color={labelColor.normalText}>Target TAT</Span>
                    <Span color={labelColor.normalText}>
                      {formatMs(mapData.trip.targetTransitTime)}
                    </Span>
                  </Flex>
                  {data?.tripPois?.length > 0 ? (
                    <label
                      style={{
                        fontSize: '14px',
                        color: '#887e7e',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={showTripPois}
                        onChange={e => {
                          setShowTripPois(!showTripPois)
                        }}
                      />{' '}
                      Trip P.O.Is
                    </label>
                  ) : null}
                </MapDescription>
              </>
            ) : null}
            <TripMap
              {...{ ...mapData }}
              mapKey={mapKey}
              aerisLayer={aerisLayer}
              selectedIds={selectedIds}
              defaultBaseLayer={defaultBaseLayer}
              moveMarker={moveMarker}
            />
          </Flex>
        </Grid>
      ) : null}
      <NewCard style={{ border: 'none' }}>
        <NewCard.Header>
          <SidebarListingContainer containerStyle={style.tripTabs}>
            <SideBarListing
              isSelected={sideBarTab === 'tripDetails'}
              id={'tripDetails'}
              onClick={() => setSideBarTab('tripDetails')}
            >
              {`${tripDetailConstant.tripDetails}`}
            </SideBarListing>
            {'exceptions' in data && data.exceptions !== null && (
              <SideBarListing
                isSelected={sideBarTab === 'exceptions'}
                id={'exceptions'}
                onClick={() => setSideBarTab('exceptions')}
              >
                {`${tripDetailConstant.exceptions} `}(
                <Span>{mapData.exceptions.length}</Span>)
              </SideBarListing>
            )}
            {'stoppages' in data && data.stoppages !== null && (
              <SideBarListing
                isSelected={sideBarTab === 'stoppages'}
                id={'stoppages'}
                onClick={() => setSideBarTab('stoppages')}
              >
                {`${tripDetailConstant.stoppage} `}(
                <Span>{mapData.stoppages.length}</Span>)
              </SideBarListing>
            )}
            {'histories' in data && data.histories !== null && (
              <SideBarListing
                isSelected={sideBarTab === 'history'}
                id={'history'}
                onClick={() => setSideBarTab('history')}
              >
                {`${tripDetailConstant.history}`}
              </SideBarListing>
            )}
            {'histories' in data && data.histories !== null && is_weight && (
              <SideBarListing
                isSelected={sideBarTab === 'loadsensor'}
                id={'loadsensor'}
                onClick={() => setSideBarTab('loadsensor')}
              >
               {`${tripDetailConstant.loadsensor}`}
              </SideBarListing>
            )}
            {'histories' in data && data.histories !== null && is_document && (
              <SideBarListing
                isSelected={sideBarTab === 'documents'}
                id={'documents'}
                onClick={() => setSideBarTab('documents')}
              >
               {`${tripDetailConstant.documents}`}
              </SideBarListing>
            )}
            {'overspeedInstances' in data && !isEmpty(data.overspeedInstances) && (
              <SideBarListing
                isSelected={sideBarTab === 'overspeedInstances'}
                id={'overspeedInstances'}
                onClick={() => setSideBarTab('overspeedInstances')}
              >
                {`${tripDetailConstant.overspeedInstances} `}(
                <Span>{mapData.overspeedInstances.length}</Span>)
              </SideBarListing>
            )}
            {'epod' in data.trip && data.trip.epod ? (
              <SideBarListing
                isSelected={sideBarTab === 'epod'}
                id={'epod'}
                onClick={() => setSideBarTab('epod')}
              >
                {`${tripDetailConstant.epod}`}
              </SideBarListing>
            ) : null}
            {'issues' in data && !isEmpty(data.issues) && (
              <SideBarListing
                isSelected={sideBarTab === 'issues'}
                id={'issues'}
                onClick={() => setSideBarTab('issues')}
              >
                Issues
              </SideBarListing>
            )}
          </SidebarListingContainer>
        </NewCard.Header>
        <NewCard.Body style={{ marginBottom: '20px' }}>
          <OverflowWrapper>
            {sideBarTab === 'tripDetails' && (
              <TripDetails
                data={data}
                plant={plant}
                trip={data.trip}
                historySlider={historySlider}
                stoppageSlider={stoppageSlider}
                exceptionSlider={exceptionSlider}
                currHistorySlider={currHistorySlider}
                currStoppageSlider={currStoppageSlider}
                currExceptionSlider={currExceptionSlider}
                setCurrHistorySlider={setCurrHistorySlider}
                setCurrStoppageSlider={setCurrStoppageSlider}
                setCurrExceptionSlider={setCurrExceptionSlider}
                isShare={isShare}
                apiBased={apiBasedDailyDistanceGraph}
                tripTabItems={tripTabItems}
              />
            )}
            {sideBarTab === 'exceptions' && (
              <ExceptionsListing
                data={mapData.exceptions}
                dataLength={data.exceptions.length}
                onSelect={onSelect}
                id={selectedIds}
                exceptionSlider={exceptionSlider}
                currExceptionSlider={currExceptionSlider}
                setCurrExceptionSlider={setCurrExceptionSlider}
              />
            )}
            {sideBarTab === 'history' && (
              <HistoryListing
                id={selectedIds}
                onSelect={onSelect}
                data={mapData.histories}
                dataLength={data.histories.length}
                downloadCsv={downloadCsv}
                historySlider={historySlider}
                currHistorySlider={currHistorySlider}
                setCurrHistorySlider={setCurrHistorySlider}
                config={historyConfig}
                onTrackingProviderChange={onTrackingProviderChange}
                trackingProviders={data.trackingProviders}
                defaultTrackingProvider={trackingProvider || data.trip?.trackingProvider}
              />
            )}
            {sideBarTab === 'loadsensor' && is_weight &&(
              <LoadsensorListing
                id={selectedIds}
                onSelect={onSelect}
                data={mapData.trip}
                dataLength={data.histories.length}
                downloadCsv={downloadCsv}
                historySlider={historySlider}
                currHistorySlider={currHistorySlider}
                setCurrHistorySlider={setCurrHistorySlider}
                config={historyConfig}
              />
            )}
            {sideBarTab === 'documents' && (
              <DocumentsListing
                id={selectedIds}
                onSelect={onSelect}
                data={mapData.trip}
                dataLength={data.histories.length}
                downloadCsv={downloadCsv}
                historySlider={historySlider}
                currHistorySlider={currHistorySlider}
                setCurrHistorySlider={setCurrHistorySlider}
                config={historyConfig}
              />
            )}
            {sideBarTab === 'stoppages' && (
              <StoppageListing
                id={selectedIds}
                onSelect={onSelect}
                exceptionsData={mapData.exceptions.filter((item: any) => {
                  return (
                    item.type === 'IdleAlertSubscription' ||
                    item.type === 'UnscheduledStoppageAlertSubscription'
                  )
                })}
                data={mapData.stoppages}
                dataLength={data.stoppages.length}
                downloadCsv={downloadCsv}
                stoppageSlider={stoppageSlider}
                currStoppageSlider={currStoppageSlider}
                setCurrStoppageSlider={setCurrStoppageSlider}
              />
            )}
            {sideBarTab === 'overspeedInstances' && (
              <OverspeedListing
                id={selectedIds}
                onSelect={onSelect}
                data={mapData.overspeedInstances}
                dataLength={data.overspeedInstances.length}
                overspeedSlider={overspeedSlider}
                currOverspeedSlider={currOverspeedSlider}
                setCurrOverspeedSlider={setCurrOverspeedSlider}
              />
            )}
            {sideBarTab === 'issues' && (
              <Issues issues={data.issues} isShare={isShare} />
            )}
            {sideBarTab === 'epod' && <Epod data={data.trip.epod || {}} />}
          </OverflowWrapper>
        </NewCard.Body>
      </NewCard>
    </TripTabDetailsGrid>
  )
}

export default TripTabDetails
